/**
 * Single source of truth for authenticated app navigation (sidebar + top header).
 * `exact` on a link means NavLink uses `exact` for active matching.
 */
const OVERVIEW_GROUP = {
  id: 'overview',
  title: 'Overview',
  links: [{ to: '/', title: 'Dashboard', icon: 'icofont-ui-home', exact: true }],
};

const OPERATIONS_BASE_LINKS = [
  { to: '/cft-calculator', title: 'Generate Quotation', icon: 'icofont-calculator-alt-2' },
  { to: '/create-barcode', title: 'Create Barcode', icon: 'icofont-barcode' },
  { to: '/create-job', title: 'New Job', icon: 'icofont-truck-alt' },
];

const DOCUMENT_GROUP = {
  id: 'documents',
  title: 'Document list',
  links: [
    { to: '/jobs', title: 'All Jobs', icon: 'icofont-sub-listing' },
    { to: '/quotations', title: 'Quotations', icon: 'icofont-listing-box' },
    { to: '/barcode', title: 'Barcode Library', icon: 'icofont-lens' },
  ],
};

export const APP_SIDEBAR_NAV_GROUPS = [
  {
    ...OVERVIEW_GROUP,
  },
  {
    id: 'operations',
    title: 'Operations',
    links: [
      ...OPERATIONS_BASE_LINKS,
      { to: '/operations/contacts', title: 'People directory', icon: 'icofont-address-book' },
    ],
  },
  { ...DOCUMENT_GROUP },
];

export const APP_HEADER_NAV_GROUPS = [
  { ...OVERVIEW_GROUP },
  {
    id: 'operations',
    title: 'Operations',
    links: [
      ...OPERATIONS_BASE_LINKS,
      { to: '/operations/team', title: 'Invite team', icon: 'icofont-users-alt-5' },
      { to: '/operations/contacts', title: 'People directory', icon: 'icofont-address-book' },
    ],
  },
  { ...DOCUMENT_GROUP },
];

export function pathMatchesNavLink(pathname, link) {
  if (link.exact) return pathname === link.to;
  return pathname === link.to || pathname.startsWith(`${link.to}/`);
}

export function isOperationsArea(pathname) {
  return pathname === '/operations/search' || pathname.startsWith('/operations/');
}

/** Active nav group: includes e.g. /operations/search even though it is not a sidebar row. */
export function isGroupNavActive(pathname, group) {
  if (group.id === 'operations' && isOperationsArea(pathname)) return true;
  return group.links.some((link) => pathMatchesNavLink(pathname, link));
}

export function isAnyLinkInGroupActive(pathname, group) {
  return group.links.some((link) => pathMatchesNavLink(pathname, link));
}
